var popupShowKeys = ["popupPortalEl", "wrapperClassname", "hasOverlay", "isInIframe", "closeFromOverlay", "beforeShowCallback", "beforeHideCallback", "afterHideCallback", "afterShowCallback"];
export var getPopupShowConfig = function (config, legacyCallback) {
    var popupShowConfig = {};
    popupShowConfig.legacyCallback = legacyCallback;
    popupShowConfig.hasCloseBtn = (config.crossBtn === false) ? false : true;
    config.offsetTop !== undefined && (popupShowConfig.offsetTop = config.offsetTop);
    popupShowKeys.forEach(function (key) {
        config[key] !== undefined && (popupShowConfig[key] = config[key]);
    });
    return popupShowConfig;
};
//# sourceMappingURL=getPopupShowConfig.js.map